<div id="reportePDF" class="container">

      <div id="pag1" class="row justify-content-between p-3 p-md-3 text-black rounded">
        
        <div class="col-12 text-center" style="padding-top: 25px; padding-bottom: 25px;">
            <h1 class="font-italic">Resultados - {{nombreEncuesta}}</h1>
        </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-6">
          <table id="pag3" class="table table-sm table-striped table-bordered">
            <tbody>
              <tr>
                <th scope="row" >Carné</th>
                <td>{{informacionParaPDF[0].registro}}</td>
              </tr>
              <tr>
                <th scope="row">Nombre</th>
                <td>{{informacionParaPDF[0].nombre}}</td>
              </tr>
              <tr>
                <th scope="row">Carrera</th>
                <td>{{ informacionParaPDF[0].carrera }}</td>
              </tr>
              <tr>
                <th scope="row">Sección</th>
                <td>{{ informacionParaPDF[0].seccion }}</td>
              </tr>
              <tr>
                <th scope="row">Conteo Estudiantes</th>
                <td>{{ informacionParaPDF[0].conteoEstudiantes }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="row justify-content-center" style="padding-bottom: 25px;">
            <div class="col-12">
              <canvas id="realtime" style="width: 150vh; height: 80vh">{{ chart }}  </canvas>
            </div>
      </div>
      <div class="row justify-content-center">
        <div class="col-6">
          <table id="pag2" class="table table-sm table-striped table-bordered">
            <thead>
              <tr>
                <th scope="col">Factor</th>
                <th scope="col">Resultado</th>
                <th scope="col">Interpretacion</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor = "let item of informacionParaPDF" >
                <td>{{item.baremo}}</td>
                <td>{{item.puntuacion}}</td>
                <td>{{item.interpretacion}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="row" id="texto" *ngIf='id_encuesta==3'>        
        <div class="col-12">
          <h5 class="text-center">SUGERENCIAS</h5>
          <p>
            El estilo de aprendizaje se refiere al conjunto de características cognitivas, afectivas y sicológicas
            involucradas en la forma individual en que piensan y actuan las personas cuando aprenden. Los estilos de
            aprendizaje son relativamente estables pero propensos al cambio, pueden ser diferentes en situaciones
            distintas, tienen tendencia a ser mejorados con un buen nivel de conciencia del estilo personal de
            aprendizaje y aprovechados para desarrollar la capacidad de aprendizaje autónomo. A continuación se
            presentan las características de cada estilo de aprendizaje, con el propósito de orientarle para que pueda
            aprovechar las fortalezas del estilo en que muestre una preferencia alta o muy alta, así como desarrollar
            los que presenten preferencia de muy baja a moderada.
          </p>
        </div>
      </div>  
      <div class="row justify-content-center" style="padding-top: 25px;" *ngIf='id_encuesta==3'>
        <div class="col-8" style="margin-bottom: 10px;" *ngFor="let sugerencia of sugerencias">
          <h5 class="text-center">ESTILO {{sugerencia.estilo.toUpperCase()}}: Preferencia {{sugerencia.preferencia.toLowerCase()}}</h5>
          <table class="table table-striped table-bordered">
            <thead>
              <tr>
                <th scope="col">Propiedad</th>
                <th scope="col">Sugerencia</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td scope="row">Caracteristicas principales</td>
                <td>{{sugerencia.caracteristicas}}</td>
              </tr>
              <tr>
                <td scope="row">Otras características</td>
                <td>{{sugerencia.otrasCaracteristicas}}</td>
              </tr>
              <tr>
                <td scope="row">Sugerencias extra</td>
                <td>{{sugerencia.sugerencias}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="row justify-content-center" style="padding-top: 25px;" *ngIf='id_encuesta==2'>
          <h5 class="text-center">SUGERENCIAS PARA MEJORAR SU ACTITUD HACIA LA MATEMÁTICA</h5>
          <p>El desarrollo de una actitud favorable hacia la Matemática requiere de estudio continuo para aumentar la
            confianza en la capacidad personal de aprendizaje, mientras más esfuerzo se realice mayor será la
            habilidad que se adquiera y esto permitirá reducir el temor, ansiedad o nerviosismo que pueda
            experimentarse. Estudiar todos los días es una muestra de la motivación y el interés por aprender, para
            ello se requiere además de asistir a clases, consultar varios libros y materiales disponibles, preguntar,
            resolver problemas y ejercicios de alto nivel de dificultad, explicar procedimientos, cuestionar respuestas,
            entre otros. A medida que se avance en el estudio de temas matemáticos, es importante pensar e investigar
            su utilidad teórica o práctica en la carrera de ingeniería elegida.</p>
            <p><b>Importante: </b>
              La actitud hacia la matemática y hacia la ciencia es un aspecto personal que puede mejorarse
              de forma continua durante toda la formación como profesional de la ingeniería, por eso es importante
              mantener una actitud favorable desde el inicio de la carrera.
            </p>
      </div>
      <div class="row justify-content-center" style="padding-top: 25px;" *ngIf='id_encuesta==3'>
        <h5 class="text-center">SUGERENCIAS PARA APROVECHAR Y FORTALECER EL ESTILO PERSONAL DE
          APRENDIZAJE</h5>
        <p>El estilo de aprendizaje se refiere al conjunto de características cognitivas, afectivas y sicológicas
          involucradas en la forma individual en que piensan y actuan las personas cuando aprenden. Los estilos de
          aprendizaje son relativamente estables pero propensos al cambio, pueden ser diferentes en situaciones
          distintas, tienen tendencia a ser mejorados con un buen nivel de conciencia del estilo personal de
          aprendizaje y aprovechados para desarrollar la capacidad de aprendizaje autónomo. A continuación se
          presentan las características de cada estilo de aprendizaje, con el propósito de orientarle para que pueda
          aprovechar las fortalezas del estilo en que muestre una preferencia alta o muy alta, así como desarrollar
          los que presenten preferencia de muy baja a moderada</p>
      </div>
      <div class="row justify-content-center">
        <button type="button" class="btn btn-primary" (click)="imprimirPDF()" [disabled]="!generateReport">Imprimir reporte en PDF</button>        
      </div>
</div>